import { UsersRoutePath } from "#src/routes/settings/users";
import { RoutePath } from "#src/utils/route";

export const UserGroupsRoutePath = UsersRoutePath.concat(
  new RoutePath({
    path: "/groups",
    title: "User Groups",
  })
);
